export default "__VITE_ASSET__Di$cd38E__"